import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';

// Components 
import LinearProgress from '@mui/material/LinearProgress';
import InfoRow from '../../../general/inputs/InfoRow';
import getStatusColor from '../../../../util/style/getStatusColor';
import getCapitalizedString from '../../../../util/style/getCapitalizedString';
import Button from '../../../general/inputs/Button';
import DataBox from '../../../general/data/DataBox';

const Invoices: React.FC = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const colors = useAppSelector(state => state.theme.colors);  
    const invoices = useAppSelector(state => state.billing.invoices);  

    const navigateToPdfUrl = (pdfUrl: string) => () => { 
        if (pdfUrl) { 
            window.open(pdfUrl, '_blank');
        }; 
    }; 
    
    return (
        <Box sx={{ width: '100%', maxWidth: '600px' }}>
            <DataBox 
                title={String(t('invoices'))}  
                description={(invoices?.length > 0) ? '' : String(t('noInvoiceDetected'))} 
            >
                {invoices?.map((invoice: any, index: any) => { 
                    return <InfoRow
                            key={index}
                            title={moment.unix(invoice?.created).utc(true).format('LL')}
                            icon={ 
                                <strong 
                                    style={{ 
                                        padding: '5px 8px',
                                        borderRadius: 7,
                                        backgroundColor: getStatusColor(invoice?.status), 
                                        color: 'white', 
                                        fontSize: '12px',
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    {getCapitalizedString(String(t(invoice?.status)))}
                                </strong>
                            }
                            description={
                                invoice?.invoice_pdf ? 
                                <Button 
                                    title='download'
                                    triggerFunction={navigateToPdfUrl(invoice?.invoice_pdf)}
                                /> : `$${(invoice?.amount_paid / 100).toFixed(2)}`
                            }
                            extraStyle={{ 
                                width: '98%', 
                                marginLeft: '1%', 
                                '&:hover': { 
                                    backgroundColor: 'transparent', 
                                    cursor: 'default' 
                                }
                            }}
                            descriptionStyle={{ fontSize: 14, color: 'rgb(130, 130, 130)'}}
                    />
                })}
            </DataBox>
        </Box>
    );
};

export default Invoices;